var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "bookings.show", params: { id: this.booking.id } },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "categories",
          fn: function () {
            return [
              _vm.booking.opportunities.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    _vm._l(_vm.booking.opportunities, function (app) {
                      return _c(
                        "span",
                        { key: app.id, staticClass: "label label-info" },
                        [_vm._v(_vm._s(app.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "status",
          fn: function () {
            return [
              _c("div", { staticClass: "spacer-b-2" }, [
                _vm.bookingIsContextuallyCancelled
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Cancelled"),
                    ])
                  : _vm.bookingIsScheduled
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Scheduled"),
                    ])
                  : _vm.bookingIsOnHold
                  ? _c("span", { staticClass: "label label-info" }, [
                      _vm._v("On Hold"),
                    ])
                  : _vm.bookingIsBooked
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Booked"),
                    ])
                  : _vm.bookingIsCompleted
                  ? _c("span", { staticClass: "label label-info" }, [
                      _vm._v("Completed"),
                    ])
                  : _vm.bookingHasExpired
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Expired"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && _vm.bookingIsNotPublic
                  ? _c("span", { staticClass: "label label-hidden" }, [
                      _vm._v("Hidden"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$paymentsModuleEnabled &&
                _vm.userCanSeePaymentStatus &&
                _vm.bookingPaymentFinalIsPaid
                  ? _c("span", { staticClass: "label label-success" }, [
                      _c("i", { staticClass: "fa fa-check fa-fw" }),
                      _vm._v(" Full Payment"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$vlastMode &&
                _vm.$paymentsModuleEnabled &&
                _vm.userCanSeePaymentStatus &&
                _vm.bookingPaymentFullIsPaid
                  ? _c("span", { staticClass: "label label-success" }, [
                      _c("i", { staticClass: "fa fa-check fa-fw" }),
                      _vm._v(" Full Payment"),
                    ])
                  : _vm.$paymentsModuleEnabled &&
                    _vm.userCanSeePaymentStatus &&
                    _vm.bookingPaymentDepositIsPaid
                  ? _c("span", { staticClass: "label label-success" }, [
                      _c("i", { staticClass: "fa fa-check fa-fw" }),
                      _vm._v(" Deposit Paid"),
                    ])
                  : _vm.$paymentsModuleEnabled &&
                    _vm.userCanSeePaymentStatus &&
                    _vm.bookingPaymentDepositIsUnpaid
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _c("i", { staticClass: "fa fa-times fa-fw" }),
                      _vm._v(" Deposit Unpaid"),
                    ])
                  : _vm.$paymentsModuleEnabled &&
                    _vm.userCanSeePaymentStatus &&
                    _vm.bookingPaymentDepositIsSent
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Deposit Sent"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$paymentsModuleEnabled &&
                _vm.userCanSeePaymentStatus &&
                _vm.bookingPaymentFinalIsSent
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Final Sent"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.booking.urgent
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ])
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  !_vm.booking.is_offer &&
                  (_vm.$userIsTalent || _vm.$userIsManager)
                    ? [
                        _vm.booking.local_currency
                          ? [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .local_currency_budget_per_star_as_user_rate,
                                        _vm.booking.local_currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .budget_per_star_as_user_rate,
                                        _vm.booking.currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ],
                      ]
                    : _vm.bookingGrandTotalBudget
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("nullable")(
                              _vm._f("abbreviatedCurrency")(
                                _vm.bookingGrandTotalBudget,
                                _vm.booking.local_currency
                                  ? _vm.booking.local_currency
                                  : _vm.booking.currency
                              )
                            )
                          )
                        ),
                      ])
                    : _c("span", [_vm._v("View")]),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingIsNotPublic && _vm.$userIsAdmin
                ? _c(
                    "meta-item",
                    {
                      staticClass: "text-danger",
                      attrs: { icon: "eye-slash" },
                    },
                    [_vm._v("Hidden")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingIsCompleted && _vm.$userIsAdmin
                ? _c("meta-item", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.bookingOnlineCompletionDate) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }